import { SpecialDataSourceId } from '@upright/common/model/input/data-sources/types';
import { ModelEntityType } from '@upright/common/model/input/types';
import { getEntityType } from '@upright/common/utils';
import { useGetGroupfolioQuery } from '@upright/ui/api/model/input/company-groups/hooks';

export function useHoldingsSourceDescription(entityId: string | undefined) {
  const entityType = entityId ? getEntityType(entityId) : undefined;
  const groupfolioId =
    entityType === ModelEntityType.GROUP || entityType === ModelEntityType.PORTFOLIO ? entityId : undefined;
  const groupfolioQuery = useGetGroupfolioQuery(groupfolioId);
  return groupfolioQuery.data?.source === SpecialDataSourceId.PITCHBOOK
    ? 'Fund holdings data source: Pitchbook Data, Inc'
    : undefined;
}
